<script setup lang="ts">
import { Check, Download } from 'lucide-vue-next'
import type { ConfirmableItem, DownloadDocumentsRequest } from '~/types/web-chat'

defineProps<{ request: DownloadDocumentsRequest }>()

const emit = defineEmits<{
  'download-document': [item: ConfirmableItem]
}>()

const { t } = useI18n()
</script>

<template>
  <div class="mt-3 rounded-lg border border-primary/20 bg-primary-lighter p-3">
    <div class="flex items-start gap-2">
      <div class="mt-0.5 h-5 w-5 rounded-full bg-primary-light flex items-center justify-center shrink-0">
        <Download class="h-3 w-3 text-primary" />
      </div>
      <div class="min-w-0 flex-1">
        <p class="text-xs font-medium text-foreground">{{ t('webChat.download.title') }}</p>
        <p
          v-if="request.reason"
          class="mt-1 text-xs text-muted-foreground leading-relaxed"
        >
          {{ request.reason }}
        </p>
        <div class="mt-2.5 flex flex-col gap-1.5">
          <button
            v-for="item in request.items"
            :key="item.id"
            type="button"
            class="inline-flex items-center gap-1.5 rounded-md border border-border px-2.5 py-1.5 text-xs font-medium text-foreground hover:bg-accent-lighter transition-colors"
            :title="request.downloaded.includes(item.id) ? t('webChat.download.downloaded') : item.name"
            @click="emit('download-document', item)"
          >
            <Check
              v-if="request.downloaded.includes(item.id)"
              class="h-3 w-3 shrink-0 text-primary"
            />
            <Download
              v-else
              class="h-3 w-3 shrink-0 text-muted-foreground"
            />
            <span class="truncate">{{ item.name }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
